import { ExportType } from '@/model';
import { getExtensionByMimeType } from './mimetype';

export const downloadFile = async (data: any, name: string) => {
  const fileBlob = await fetch(data).then(r => r.blob());
  const fileType = getExtensionByMimeType(fileBlob.type) ?? '';
  const fileUrl = typeof data === 'string' ? data : window.URL.createObjectURL(fileBlob);
  const downloadLink = document.createElement('a');
  downloadLink.href = fileUrl;
  downloadLink.download = `${name.toLowerCase()}.${fileType}`;
  downloadLink.click();
  window.URL.revokeObjectURL(fileUrl);
};

export const downloadPDF = (data: any, name: string) => {
  const pdfUrl = window.URL.createObjectURL(new Blob([data]));
  const downloadLink = document.createElement('a');
  downloadLink.href = pdfUrl;
  downloadLink.download = `${name.toLowerCase()}.pdf`;
  downloadLink.click();
  window.URL.revokeObjectURL(pdfUrl);
};

export const downloadExport = (data: any, name: string, type: ExportType) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.download = `${name.toLowerCase()}.${type.toLocaleLowerCase()}.`;
  downloadLink.click();
  window.URL.revokeObjectURL(url);
};

export const saveAsBlob = (data: any, name: string) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.download = `${name.toLowerCase()}`;
  downloadLink.click();
  window.URL.revokeObjectURL(url);
};
